export default "__VITE_ASSET__CZnfuDmv__"